import { HealthConditionDetailContainer } from './HealthConditionsDetailsContainer';
import {
  useGetHealthConnectionL4DetailV2,
  useGetDiseaseRiskL4DetailV2,
} from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { useParams } from 'react-router-dom';
import { useIsProUser } from '@/hooks/useIsProUser';

const HealthConnectionDetail = ({
  conditionName,
  scoreId,
}: {
  conditionName: string;
  scoreId: number;
}) => {
  const { data: conditionDetailData, isLoading } = useGetHealthConnectionL4DetailV2(
    conditionName,
    scoreId,
  );
  return (
    <HealthConditionDetailContainer
      condition={conditionDetailData && conditionDetailData}
      isLoading={isLoading}
      scoreId={scoreId}
    />
  );
};

const DiseaseRiskDetail = ({
  conditionName,
  scoreId,
}: {
  conditionName: string;
  scoreId: number;
}) => {
  const { data: conditionDetailData, isLoading } = useGetDiseaseRiskL4DetailV2(
    conditionName,
    scoreId,
  );
  return (
    <HealthConditionDetailContainer
      condition={conditionDetailData && conditionDetailData}
      isLoading={isLoading}
      scoreId={scoreId}
    />
  );
};

export const HealthConditionDetailPage = () => {
  const { condition: conditionName, id: scoreId } = useParams();
  const isProUser = useIsProUser();

  return (
    <div className="dark bg-black h-full w-full">
      {isProUser ? (
        <DiseaseRiskDetail conditionName={conditionName || ''} scoreId={Number(scoreId)} />
      ) : (
        <HealthConnectionDetail conditionName={conditionName || ''} scoreId={Number(scoreId)} />
      )}
    </div>
  );
};
